/** markdown-it 流程图：```mermaid 代码块 → 待渲染的 pre */
module.exports = function markdownItDocMermaid(md, options) {
  const className = (options && options.className) || 'doc-mermaid mermaid';

  function wrapFence(wrapped) {
    return function fenceRenderer() {
      const tokens = arguments[0];
      const idx = arguments[1];
      const token = tokens[idx];
      const lang = (token.info || '').trim().split(/\s+/)[0].toLowerCase();
      if (lang === 'mermaid') {
        const code = token.content
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;');
        return `<pre class="${className}">${code}</pre>\n`;
      }
      return wrapped.apply(this, arguments);
    };
  }

  const fence = md.renderer.rules.fence;
  const codeBlock = md.renderer.rules.code_block;
  md.renderer.rules.fence = wrapFence(fence);
  md.renderer.rules.code_block = wrapFence(codeBlock);
};
